import * as accountApi from './account';
import * as fileApi from './file'
import * as adminApi from './admin';
import * as commonApi from './common';
import * as diagnosisApi from './aiDiagnosis'
import * as userApi from './user';
import * as userManageApi from './userManage'
import * as onlineServiceApi from './onlineService'
const obj={
    accountApi,fileApi,adminApi,commonApi,diagnosisApi,userApi,userManageApi,onlineServiceApi
}
export default obj;